























































import { Component, Vue } from 'vue-property-decorator';
import AppSidebar from '@/components/app-sidebar/AppSidebar.vue';
import MusicPlayer from '@/components/music-player/Player.vue';
import AlbumUploadDock from '@/components/album-upload/AlbumUploadDock.vue';

@Component({
  components: {
    AppSidebar,
    MusicPlayer,
    AlbumUploadDock
  }
})
export default class extends Vue {}
